export const onHoldStatusValues = [
  "LLM",
  "LLM Ordered",
  "eTS4",
  "K25",
  "Other",
  "RFI",
];
